import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchHelper } from '../../helpers/fetch';

import type { Profile } from '@vgtv/api-client/lib/cnp_tag';
import type { Vendor } from '../../types';

export const fetchProfiles = createAsyncThunk(
  'profiles/fetch',
  ({ dataUrl }: { dataUrl: string; vendor: Vendor }) => {
    return fetchHelper<Profile[]>(dataUrl);
  }
);
